import { createFileRoute, redirect } from "@tanstack/react-router";
import { sitzungQuery } from "@/auth";
import { Settings } from "@/pages/team/Settings";

/**
 * Einstellungen sind Inhaber-Sache (03.09.2026): Ein Mitglied landet sanft
 * auf der Team-Seite, wo die Rollen erklärt sind — die eigentliche Abweisung
 * macht das Backend (Inhaber-Schranke, 403).
 */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/einstellungen")({
	beforeLoad: async ({ context }) => {
		const sitzung = await context.queryClient.ensureQueryData(sitzungQuery);
		if (sitzung?.teamRolle !== "inhaber") {
			throw redirect({ to: "/team" });
		}
	},
	component: Settings,
});
